import { render, staticRenderFns } from "./MyClassesDetail.vue?vue&type=template&id=6fd197f5&scoped=true&"
import script from "./MyClassesDetail.vue?vue&type=script&lang=ts&"
export * from "./MyClassesDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MyClassesDetail.vue?vue&type=style&index=0&id=6fd197f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd197f5",
  null
  
)

export default component.exports